import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSettings } from '@/store/user'
import { onMounted, ref, watch } from 'vue'
import { QuillyEditor } from 'vue-quilly'
import Quill, { Delta, Range } from 'quill'
import 'quill/dist/quill.snow.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'SemanticHTMLEditor',
  props: {
  modelValue: String,
  userMarket: String,
  userModel: String
},
  setup(__props) {

/* eslint-disable */
const user = useSettings();

const editor = ref<InstanceType<typeof QuillyEditor>>()
const model = ref<string>()
let quill: Quill | undefined

const props = __props

watch(() => props.modelValue, (newVal) => {
  model.value = newVal || ''
})

const options = ref({
  theme: 'snow',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: '1' }, { header: '2' }],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['clean']
    ]
  },
  placeholder: 'Insert text here ...',
  readOnly: false
})

onMounted(() => {
  quill = editor.value?.initialize(Quill)!
})

const onModelValueChange = (value) => {
  const market = props.userMarket || null;
  const key = props.userModel || null;

  user.$patch({ translations: { [market]: { [key]: value } } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QuillyEditor), {
    ref_key: "editor",
    ref: editor,
    modelValue: model.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      onModelValueChange
    ],
    options: options.value,
    "is-semantic-html-model": true,
    class: "font-normal field-sizing-fixed w-full h-64 bg-white text-black"
  }, null, 8, ["modelValue", "options"]))
}
}

})